export default __webpack_public_path__ + "static/media/S2F_Logo_Tagline_EN.bf2ed0bc.svg";